module.exports = __webpack_public_path__ + "img/11.7a119a33.png";